// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2bfa8ed2","732":"dc08a912","977":"9b232d1b"}[chunkId] + ".chunk.js";
};